import {MedicationCheckupStep, MedicationCheckupStepDeclaration} from "@/medication-checkup/interfaces";
import {parseAgendaDate} from "@/agenda/lib/agendaTime";

/**
 * What a step says of its appointment, in its header: the day it is booked
 * on, or that none is, while the step is still to hold.
 *
 * Only a step held with the patient after the first is planned: the first
 * one is being held, and a step without the patient has no appointment.
 * A completed step has nothing left to plan, and a server that does not
 * plan steps serves no date to speak of.
 */
export const plannedLabel = (
    step: MedicationCheckupStep,
    declaration: MedicationCheckupStepDeclaration | null
): {label: string; booked: boolean} | null => {
    if (step.planned_at === undefined || step.status === 'completed' || !declaration?.with_patient || step.position === 1) {
        return null;
    }

    return step.planned_at === null
        ? {label: 'Aucun RDV prévu', booked: false}
        : {label: parseAgendaDate(step.planned_at).format('[RDV le] D MMM [à] HH:mm'), booked: true};
};
